import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { CalculatorPageState } from "./models/CalculatorPageState";
import { fetchFinancingStructureAsync, fetchPeriodFeeAsync } from "./calculatorAsyncActions";
import { applyContractPeriodChange } from "./calculatorReducers";

export const extraReducers = (builder: ActionReducerMapBuilder<CalculatorPageState>) => {
  builder
    .addCase(fetchFinancingStructureAsync.pending, (state) => {
      state.form.loadingFinancingStructure = true;
      delete state.form.loadingFinancingStructureError;
    })
    .addCase(fetchFinancingStructureAsync.fulfilled, (state, action) => {
      const financingStructure = action.payload;
      const defaultContractLengthInMonths = financingStructure.availableContractLengths.find((x) => x.monthsFrom === financingStructure.defaultMonthsFrom);
      state.form.loadingFinancingStructure = false;
      state.financingStructure = financingStructure;
      state.form.purchasePrice = financingStructure.purchasePriceFrom;
      state.form.downPayment =
        defaultContractLengthInMonths && (financingStructure.purchasePriceFrom * defaultContractLengthInMonths.downPaymentRange.defaultValue) / 100;
      state.availableContractPeriods = financingStructure.availableContractLengths.map((x) => x.monthsFrom);
      state.form.contractPeriodInMonths = financingStructure.defaultMonthsFrom;
      applyContractPeriodChange(state);
    })
    .addCase(fetchFinancingStructureAsync.rejected, (state, action) => {
      if (action.error.name !== "AbortError") {
        state.form.loadingFinancingStructure = false;
        state.form.loadingFinancingStructureError = action.error.message;
      }
    })
    .addCase(fetchPeriodFeeAsync.pending, (state) => {
      delete state.form.loadingPeriodFeeError;
      delete state.form.periodFee;
    })
    .addCase(fetchPeriodFeeAsync.fulfilled, (state, action) => {
      state.form.loadingPeriodFee = false;
      state.form.periodFee = action.payload.periodFee;
    })
    .addCase(fetchPeriodFeeAsync.rejected, (state, action) => {
      if (action.error.name !== "AbortError") {
        state.form.loadingPeriodFee = false;
        state.form.loadingPeriodFeeError = action.error.message;
      }
    });
};
